/* hb-reveal.js
   Polish-layer scroll reveal. IntersectionObserver-driven; no library.

   Targets:
     1. Any element with [data-hb-reveal] OR class .hb-reveal (explicit opt-in).
     2. Selected custom-hb-* section internals, auto-attached on load.
   Each element fires once when ~80% in view, then is unobserved.

   Respects prefers-reduced-motion via CSS.
*/

(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Auto-attach .hb-reveal to common section content blocks. */
  var autoSelectors = [
    '.hb-routine__intro',
    '.hb-routine__steps > *',
    '.hb-compare__intro',
    '.hb-compare__rows',
    '.hb-voices__intro',
    '.hb-voices__list > *',
    '.hb-story__copy',
    '.hb-story__media',
    '.hb-sub-cta__inner',
    '.hb-faq__list > *'
  ];
  document.querySelectorAll(autoSelectors.join(',')).forEach(function (el) {
    el.classList.add('hb-reveal');
  });

  var nodes = document.querySelectorAll('.hb-reveal, [data-hb-reveal]');
  if (!nodes.length) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px'
  });

  nodes.forEach(function (n) { io.observe(n); });
})();
